import React from 'react';
import _ from "lodash";
import { withResolver, withDebug } from 'components/common';
import {
  FormGroup,
  required,
  SaveButton,
  BackButton,
  DatePicker,
} from 'components/common/Forms';
import moment from 'moment';
import { compose, withState, withProps, withPropsOnChange, withHandlers, lifecycle } from 'recompose';
import { Control, actions, LocalForm, Errors } from 'react-redux-form';
import {
  Row,
  Col,
  Button,
  Card,
  CardBody,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
} from 'reactstrap';
import { Installer } from 'config/roles';
import ChangeStatus from './ChangeStatus';
import Select from 'react-select';
import { NotificationManager } from 'react-notifications';
import { includes, merge } from 'lodash';
import { nullBooleanDropdown } from '../common';
import withLifecycle from '@hocs/with-lifecycle';
const Aux = props => props.children;


export const Edit = ({
  onChange,
  onUpdate,
  item,
  onSubmit,
  onSubmitFailed,
  onBack,
  setDispatch,
  dispatch,
  form,
  installationTypes,
  fuelTypes,
  jobTypes,
  devices,
  voltages,
  rejectionReasons,
  additionalEquipment,
  jobStatuses,
  jobSubStatuses,
  installers,
  readOnly,
  pricing,
  accepted,
  isInstaller,
  client,
  setRefresh,
  onChanged,
  isAssigning,
  setIsAssigning,
  isChangingStatus,
  setIsChangingStatus,
  rejectOrder,
  rejectModal,
  selectedJobStatus,
  onJobStatusChange,
  setJobSubStatuses,
  isSubStatusDisabled,
  setSubStatusDisabled,
  jobSubStatusOptions,
  setjobSubStatusOptions,
  countries
}) => {
  
  // Will later be used to mantain search results when going back
  const handleBack = () => {
    onBack();
    sessionStorage.setItem('onBack', true);
  };

  return (
  <LocalForm
    onChange={onChange}
    onUpdate={onUpdate}
    onSubmit={onSubmit}
    onSubmitFailed={onSubmitFailed}
    getDispatch={setDispatch}
    initialState={item}
  >
    <Row>
      <Col>
        <h3> Customer Details </h3>
      </Col>
      {
        'white_label_partner' in item &&
        <div className='d-flex'>
          <div className='ml-auto flex-column mr-5'>
            <div className='ml-auto font-weight-bold text-center'>
              {item.white_label_partner.name}
            </div>
            <div>
              <img
                style={{maxHeight: '20vh' }}
                src={item.white_label_partner.logo_image}
                alt="White Label Partner Logo"
              />
            </div>
          </div>
        </div>
      }
    </Row>
    <hr />
    <Row>
      <Col>
        <FormGroup label="Company Name" model=".company_name">
          <Control.input
            updateOn="blur"
            readOnly={readOnly}
            model=".company_name"
            type="text"
            required
          />
        </FormGroup>
        <FormGroup label="Address Line 1" model=".address_1">
          <Control.input
            updateOn="blur"
            readOnly={readOnly}
            model=".address_1"
            type="text"
            required
            maxLength={100}
          />
        </FormGroup>
        <FormGroup label="Town/City" model=".city">
          <Control.input
            updateOn="blur"
            readOnly={readOnly}
            model=".city"
            type="text"
            required
          />
        </FormGroup>
        <FormGroup label="Postcode" model=".postcode">
          <Control.input
            updateOn="blur"
            readOnly={readOnly}
            model=".postcode"
            type="text"
          />
        </FormGroup>
        <FormGroup label="Contact Number" model=".contact_number">
          <Control.input
            updateOn="blur"
            readOnly={readOnly}
            model=".contact_number"
            type="text"
            required
          />
        </FormGroup>
      </Col>
      <Col>
        <FormGroup label="Contact Name" model=".contact_name">
          <Control.input
            readOnly={readOnly}
            updateOn="blur"
            model=".contact_name"
            type="text"
            required
          />
        </FormGroup>
        <FormGroup label="Address Line 2" model=".address_2">
          <Control.input
            readOnly={readOnly}
            updateOn="blur"
            model=".address_2"
            type="text"
            maxLength={100}
          />
        </FormGroup>
        <FormGroup label="County" model=".county">
          <Control.input
            readOnly={readOnly}
            updateOn="blur"
            model=".county"
            type="text"
          />
        </FormGroup>
        <FormGroup label="Country" model=".country">
          <Control.select 
            model=".country"
            readOnly={readOnly}
            required
            validators={{
                    requiredAndValid: (val) => countries.some(country => country.name === val),
                  }}
            >
            <option />
            {countries.map(i => (
              <option key={`country-${i.id}`} value={i.name}>
                {i.name}
              </option>
            ))}
          </Control.select>
          <Errors
            model=".country"
            messages={{
              requiredAndValid: `Please select a Country`,
            }}
            wrapper={props => (
              <span className="small text-danger form-text">
                {props.children}
              </span>
            )}
          />
        </FormGroup>
        <FormGroup label="Contact Email" model=".contact_email">
          <Control.input
            updateOn="blur"
            readOnly={readOnly}
            model=".contact_email"
            type="email"
            required
          />
        </FormGroup>
      </Col>
    </Row>
    <FormGroup label="Dispatch Address (Show only when it’s different with install address)" model=".dispatch_address">
      <Control.input
        updateOn="blur"
        readOnly={readOnly}
        model=".dispatch_address"
        type="text"
      />
    </FormGroup>
    <hr/>
    <Row>
      <Col>
        <h3>Order Details</h3>
        <FormGroup label="Order Ref" model=".order_ref">
          <Control.input readOnly={true} model=".order_ref" type="text" />
        </FormGroup>
        <FormGroup label="Created Date" model=".imported_at">
          <DatePicker
            className="form-control"
            calendarClassName="with-time"
            model=".imported_at"
            disabled={true}
            type="date"
            viewDateFormat="YYYY-MM-DD"
            modelDateFormat="YYYY-MM-DD"
          />
        </FormGroup>
        <FormGroup label="Job Type" model=".order_job_type">
          <Control.select disabled={readOnly || isInstaller} model=".order_job_type">
            <option />
            {jobTypes.filter(jobTypes => jobTypes.value !== 50).map(i => (
              <option key={i.value} value={i.text}>
                {i.text}
              </option>
            ))}
          </Control.select>
        </FormGroup>
        <FormGroup label="Service Desk Ticket Reference" model=".service_desk_ticket">
          <Control.input
            updateOn="blur"
            readOnly={true}
            model=".service_desk_ticket"
            type="text"
          />
        </FormGroup>
        <FormGroup label="Sales Agent Email Address" model=".sales_agent_email">
          <Control.input
            updateOn="blur"
            readOnly={true}
            model=".sales_agent_email"
            type="email"
          />
        </FormGroup>
        <FormGroup label="Job Status" model=".job_status">
          <Control.select
            disabled={readOnly}
            model=".job_status"
            validators={{ required }}
            onChange={onJobStatusChange}
          >
            {jobStatuses.map(i => (
              <option key={i.value} value={i.value}>
                {i.text}
              </option>
            ))}
          </Control.select>
        </FormGroup>
        <FormGroup label="Job Status Detail" model=".job_substatus">
            <Control.select
              disabled={readOnly || isSubStatusDisabled}
              model=".job_substatus"
              required
            >
            <option value="" disabled selected hidden>
            </option>
              {jobSubStatusOptions && jobSubStatusOptions.map(i => (
                <option key={i.value} value={i.value}>
                  {i.text}
                </option>
              ))}
            </Control.select>
          </FormGroup>
      </Col>
      <Col>
        <h3>&nbsp;</h3>
        <FormGroup label="Customer ID" model=".customer_surrogate_id">
          <Control.input readOnly={true} model=".customer_surrogate_id" type="text" />
        </FormGroup>
        {installers && item.installer_user ? (
          <FormGroup label="Installer" model=".installer_user">
            <Control.select disabled={true} model=".installer_user">
              <option />
              {installers.map(i => (
                <option key={i.id} value={i.id}>
                  {i.name}
                </option>
              ))}
            </Control.select>
          </FormGroup>
        )
        : (
          installers ?
          <FormGroup label="Installer" model=".installer">
            <Control.select disabled={true} model=".installer">
              <option />
              {installers.map(i => (
                <option key={i.id} value={i.id}>
                  {i.name}
                </option>
              ))}
            </Control.select>
          </FormGroup>
            :
            <div />
        )}
        {isInstaller &&
          accepted &&
          rejectModal && (
            <Modal isOpen={rejectModal} toggle={rejectOrder}>
              <ModalHeader toggle={rejectOrder}>
                Reject or Return an Order
              </ModalHeader>
              <ModalBody>
                <b>Unable to reject order at this stage</b>
                <div>
                  Please call the Radius Operations Team on 0800 056 4432 to
                  reject an order.
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={rejectOrder}>
                  Close
                </Button>
              </ModalFooter>
            </Modal>
          )}
        <FormGroup label="Pricing" >
          <input className="form-control" readOnly={true} value={pricing} type="text"/>
        </FormGroup>
        <FormGroup label="Issuer" model=".issuer">
          <Control.input readOnly={true} model=".issuer" type="text" />
        </FormGroup>
        <FormGroup label="Premium installation service" model=".premium_installation">
          <Control.select disabled={true} model=".premium_installation">
            {nullBooleanDropdown.map(i => (
              <option key={`premium_installation-${i.value}`} value={i.value}>
                {i.text}
              </option>
            ))}
          </Control.select>
        </FormGroup>
        <FormGroup label="Courier Tracking Number" model=".courier_tracking_number">
          <Control.input readOnly={true} model=".courier_tracking_number" type="text" />
        </FormGroup>
        <FormGroup label="Project Order" model=".project_order">
          <Control.select disabled={true} model=".project_order">
            {nullBooleanDropdown.map(i => (
              <option key={`project_order-${i.value}`} value={i.value}>
                {i.text}
              </option>
            ))}
          </Control.select>
        </FormGroup>
      </Col>
    </Row>
    <FormGroup label="Connect/Control Notes" model=".control_notes">
      <Control.textarea
        // disabled={readOnly}
        readOnly={true}
        updateOn="blur"
        model=".control_notes"
      />
    </FormGroup>
    <FormGroup label="Job Description" model=".notes">
      <Control.textarea
        disabled={readOnly}
        updateOn="blur"
        model=".notes"
      />
    </FormGroup>
    <hr />
    <Row>
      <Col>
        <h4>Install Details</h4>
        <FormGroup label="Job Number">
          <Control.input model=".id" type="number" disabled />
        </FormGroup>
        
        <FormGroup label="Device Make & Model">
          <Control.input model=".device_make_model" type="text" disabled />
        </FormGroup>
        {
          (item.hasOwnProperty("supplementary_item_types")) ? 
            (<FormGroup label="Item Type & Quantity" model=".supplementary_item_types">
              <Card className={readOnly ? 'disabled' : ''}>
                <CardBody>
                  {
                    item.supplementary_item_types.map((date, index)=>{
                      return (
                        <Control.input
                          readOnly={true}
                          updateOn="blur"
                          model={`.supplementary_item_types[${index}]`}
                          type="text"
                        />
                      )
                    })
                  }
                </CardBody>
              </Card>
            </FormGroup>) : (<FormGroup label="Item Type & Quantity" model=".supplementary_item_types">
              <Card className={readOnly ? 'disabled' : ''}>
                <CardBody>
                </CardBody>
              </Card>
            </FormGroup>)
        }
        <FormGroup label="Installation Type" model="installation_type">
          <Card className={readOnly ? 'disabled' : ''}>
            <CardBody>
              {installationTypes.map(i => { 
                // return the checkboxes, keep the checked checkboxes at the top
                if (includes(item.installation_types, i.id)) {                  
                return (
                <FormGroup
                  check
                  label={i.display_name}
                  model=".installation_types[]"
                  key={i.id}
                >
                  <Control.checkbox
                    disabled={readOnly}
                    model=".installation_types[]"
                    value={i.id}
                    changeAction={(model, id, ...props) => {
                      dispatch(actions.checkWithValue(model, id, ...props));
                      setTimeout(() => {
                        dispatch(actions.validate('local'));
                      }, 0);
                    }}
                  />
                </FormGroup>
              )}})}
              {installationTypes.map(i => { 
                // return the checkboxes, keep the checked checkboxes at the top
                if (!includes(item.installation_types, i.id)) {                  
                return (
                <FormGroup
                  check
                  label={i.display_name}
                  model=".installation_types[]"
                  key={i.id}
                >
                  <Control.checkbox
                    disabled={readOnly}
                    model=".installation_types[]"
                    value={i.id}
                    changeAction={(model, value, ...props) => {
                      dispatch(actions.checkWithValue(model, value, ...props));
                      setTimeout(() => {
                        dispatch(actions.validate('local'));
                      }, 0);
                    }}
                  />
                </FormGroup>
              )}})}
              {includes(item.installation_types, 1) && (
                <Control.input
                  readOnly={readOnly}
                  model=".installation_type_other"
                  updateOn="blur"
                  validators={{
                    required,
                  }}
                />
              )}
            </CardBody>
          </Card>
        </FormGroup>
        <FormGroup label="Additional Equipment" addControlClass={false}>
          <Control.select
            component={Select}
            placeholder="Additional Equipment"
            model=".additional_equipment"
            disabled={readOnly}
            options={additionalEquipment}
            multi
            labelKey="text"
            valueKey="text"
            isLoading={!additionalEquipment}
            changeAction={(model, value) => {
              dispatch(actions.change(model, value.map(ae => ae.text)));
            }}
          />
        </FormGroup>
        <FormGroup label="Kit Dispatched Date" model=".kit_dispatched_date">
          <DatePicker
            className="form-control"
            model=".kit_dispatched_date"
            type="date"
            viewDateFormat="YYYY-MM-DD"
            modelDateFormat="YYYY-MM-DD"
            disabled={readOnly}
          />
        </FormGroup>
        <FormGroup label="Installation Preference Dates" model=".installation_preferences_dates">
          <Control.input 
            model=".installation_preferences_dates" 
            type="text" 
            validators={{
              valid: v => /^(?:\d{4}-\d{2}-\d{2})(?:\s*,\s*\d{4}-\d{2}-\d{2}){0,2}$|^$/.test(v),
            }}
            
          />
          <Errors
            model=".installation_preferences_dates"
            messages={{
              valid: `format shall be YYYY-MM-DD and max 3 dates allowed`,
            }}
            wrapper={props => (
              <span className="small text-danger form-text">
                {props.children}
              </span>
            )}
          />
          <span className="text-muted" style={{ fontSize: '12px', marginTop: '5px', display: 'block' }}>
            Example format: yyyy-mm-dd, yyyy-mm-dd, …<br />
            Max. 3 dates<br />
          </span>
        </FormGroup>
        <FormGroup label="Appointment Date" model=".appointment_date">
          <DatePicker
            className="form-control"
            model=".appointment_date"
            type="date"
            viewDateFormat="YYYY-MM-DD"
            modelDateFormat="YYYY-MM-DD"
            disabled={readOnly}
            required={[40, 41, 76, 78].includes(parseInt(item.job_status, 10))}
          />
        </FormGroup>
        <FormGroup label="Job Completed Date" model=".job_completed_at">
          <DatePicker
            className="form-control"
            model=".job_completed_at"
            type="date"
            viewDateFormat="YYYY-MM-DD"
            modelDateFormat="YYYY-MM-DD"
            disabled={readOnly}
            required={[50, 51, 52, 70, 71, 77, 79, 80].includes(parseInt(item.job_status,10))}
          />
        </FormGroup>
      </Col>
      <Col>
        <h3>Device Details</h3>
        <FormGroup label="IMEI/Box ID" model=".imei">
          <Control.input
            readOnly={readOnly}
            model=".imei"
            required={item.order_job_type != "Miscellaneous"}
            maxLength={30}
            validators={{
              valid: v => !v || /^[a-zA-Z0-9]{1,30}$/.test(v),
            }}
          />
          <Errors
            model=".imei"
            messages={{
              valid: 'IMEI must be <=30 digits',
            }}
            wrapper={props => (
              <span className="small text-danger form-text">
                {props.children}
              </span>
            )}
          />
        </FormGroup>
        <FormGroup label="Serial No." model=".serial_number">
          <Control.input
            readOnly={readOnly}
            updateOn="blur"
            model=".serial_number"
            type="text"
          />
        </FormGroup>
        <FormGroup label="Device Type" model=".device_type_name">
          <Control.input
            disabled={true}
            model=".device_type_name"
          />
        </FormGroup>
      </Col>
      <Col>
        <h3>Vehicle Details</h3>
        <FormGroup label="Make" model=".make">
          <Control.input
            readOnly={readOnly}
            updateOn="blur"
            model=".make"
            type="text"
            required
          />
        </FormGroup>
        <FormGroup label="Model" model=".model">
          <Control.input
            readOnly={readOnly}
            updateOn="blur"
            model=".model"
            type="text"
            required
          />
        </FormGroup>
        <FormGroup label="Year of Manufacture" model=".year_of_manufacture">
          <Control.input
            readOnly={readOnly}
            updateOn="blur"
            model=".year_of_manufacture"
            type="number"
            validators={{
              length: v => !v || v.toString().length === 4,
              value: v => !v || v >= 1900 && v <= moment().year() + 1,
            }}
            changeAction={(model, value) => {
              dispatch(actions.change(model, value === '' ? null : value));
            }}
          />
          <Errors
            model=".year_of_manufacture"
            messages={{
              length: 'Must be a 4-digit year e.g. 1999',
              value: `Year must be between 1900 and ${moment().year() + 1}`,
            }}
            wrapper={props =>
              props.children.map(c => (
                <span className="small text-danger form-text">{c}</span>
              ))
            }
          />
        </FormGroup>
        <FormGroup label="Vehicle Registration" model=".vehicle_registration">
          <Control.input
            readOnly={readOnly}
            updateOn="blur"
            model=".vehicle_registration"
            type="text"
            required
          />
        </FormGroup>
        <FormGroup label="Fuel Type" model=".fuel_type">
          <Control.select
            disabled={readOnly}
            model=".fuel_type"
            validators={{ required }}
          >
            {fuelTypes.map(i => (
              <option key={i.value} value={i.value}>
                {i.text}
              </option>
            ))}
          </Control.select>
        </FormGroup>
        <FormGroup label="Voltage" model=".voltage">
          <Control.select
            placeholder="Unknown"
            model=".voltage"
            disabled={readOnly}
          >
            {voltages.map(i => (
              <option key={i.value} value={i.value}>
                {i.text}
              </option>
            ))}
          </Control.select>
        </FormGroup>
      </Col>
    </Row>
    <div className="clear-fix">
      {!readOnly && (
        <SaveButton disabled={false} form={form} className="float-right" />
      )}
      <BackButton className="float-left" onClick={handleBack} />
    </div>
  </LocalForm>
)};

const emptyPromise = Promise.resolve({ data: null });

const enhance = compose(
  withProps(({ role }) => ({ isInstaller: role === Installer })),
  withState('installationTypes', 'setInstallationTypes', []),
  withState('fuelTypes', 'setFuelTypes', []),
  withState('jobTypes', 'setJobTypes', []),
  withState('devices', 'setDevices', []),
  withState('rejectionReasons', 'setRejectionReasons', []),
  withState('voltages', 'setVoltages', []),
  withState('additionalEquipment', 'setAdditionalEquipment', []),
  withState('installers', 'setInstallers', []),
  withState('isAssigning', 'setIsAssigning'),
  withState('isChangingStatus', 'setIsChangingStatus'),
  withState('activeTab', 'setActiveTab', 0),
  withState('rejectModal', 'setRejectModal', false),
  withState('refresh', 'setRefresh', "this is here to force stuff to change"),
  withState('selectedJobStatus', 'setSelectedJobStatus', ({ item }) => item.job_status || ''),
  withState('isSubStatusDisabled', 'setSubStatusDisabled', ({item }) => {
    return ![26, 42, 50, 51, 52, 80].includes(item.job_status);
  }),
  withState('jobSubStatusOptions',  'setJobSubStatusOptions', []),
  withState('countries', 'setCountries',[]),
  withHandlers({
    onJobStatusChange: ({ setSelectedJobStatus, setSubStatusDisabled }) => (event) => {
      const newStatus = parseInt(event.target.value, 10);
      setSelectedJobStatus(newStatus);
      const shouldDisable = ![26, 42, 50, 51, 52, 80].includes(newStatus);
      setSubStatusDisabled(shouldDisable);
    },
  }),
  lifecycle({
    componentDidMount() {
      const { jobSubStatuses, selectedJobStatus, setJobSubStatusOptions } = this.props;
      if (jobSubStatuses && selectedJobStatus) {
        const subStatuses = _.get(_.find(jobSubStatuses, (obj) => obj.type && obj.type.value == selectedJobStatus), 'subStatuses', []);
      setJobSubStatusOptions(subStatuses);
      };
    },
  componentDidUpdate(prevProps) {
    const { jobSubStatuses, selectedJobStatus, setJobSubStatusOptions, setSubStatusDisabled } = this.props;

    if(prevProps.selectedJobStatus !== selectedJobStatus) {
      const disableSubStatus = ![26, 42, 50, 51, 52, 80].includes(selectedJobStatus);
      setSubStatusDisabled(disableSubStatus);
    }

    if(
      jobSubStatuses &&
      selectedJobStatus &&
      prevProps.selectedJobStatus !== selectedJobStatus
    ) {
      console.log('jobSubStatuses', jobSubStatuses);
      const subStatuses = _.get(_.find(jobSubStatuses, (obj) => obj.type && obj.type.value == selectedJobStatus), 'subStatuses', []);
      // setJobSubStatuses(jobSubStatuses);
      setJobSubStatusOptions(subStatuses);
    }
  },
  }),
  withResolver(
    {
      options: () => client =>
        client.get(
          'options?installation_types&fuel_types&job_types&devices&additional_equipment&voltages&rejection_reasons'
        ),
      installers: ({ isInstaller }) => client =>
        !isInstaller ? client.get('installers') : emptyPromise,
      deletedInstallers : ({ isInstaller }) => client =>
        !isInstaller ? client.get('deleted-installers') : emptyPromise,
      countries: () => client =>
        client.get('countries')
    },
    {
      onResolved: ({
        setInstallationTypes,
        setFuelTypes,
        setJobTypes,
        setRejectionReasons,
        setDevices,
        setVoltages,
        setAdditionalEquipment,
        setInstallers,
        setCountries,
      }) => ({
        options: {
          installation_types: installationTypes,
          fuel_types: fuelTypes,
          job_types: jobTypes,
          rejection_reasons : rejectionReasons,
          devices,
          voltages,
          additional_equipment: additionalEquipment,
        },
        installers,
        deletedInstallers,
        countries,
      }) => {
        setInstallationTypes(installationTypes);
        setFuelTypes(fuelTypes);
        setJobTypes(jobTypes);
        setRejectionReasons(rejectionReasons);
        setDevices(devices);
        setVoltages(voltages);
        setAdditionalEquipment(additionalEquipment);
        if(installers && deletedInstallers) {
          setInstallers(installers.concat(deletedInstallers));
        } else {
          setInstallers(null);
        }
        setCountries(countries);
      },
    }
  ),
  withHandlers({
    onChanged: ({ merge, setIsAssigning, setIsChangingStatus }) => value => {
      merge(value);
      setIsAssigning(false);
      setIsChangingStatus(false);
    },
    beforeSubmit: a => b => {
      return b;
    },
    rejectOrder: ({ setRejectModal, rejectModal }) => () => {
      setRejectModal(!rejectModal);
    },
    onSubmitFailed: () => form => {
      if (!form.$form.valid) {
        return NotificationManager.error(
          'Please check the form and try again.',
          'Data Invalid',
          10000
        );
      }
      return NotificationManager.error('An unexpected error occured');
    },
  }),
  withProps(({ item, isInstaller, readOnly }) => ({
    readOnly: readOnly, //  || isInstaller, // Now installers DO have permission to edit
    accepted: item.is_accepted,
  })),
  withProps(({item}) => ({
    pricing: "£ " + Number(item.job_price).toFixed(2),
  })),
  withDebug('jobStatuses'),
  withDebug('jobSubStatuses'),
);

export default enhance(Edit);



// WEBPACK FOOTER //
// ./src/pages/Jobs/Edit.jsx